import { useCallback, useState } from 'react';
import { useUser } from '@equifinance/shared';
import { Assignee } from '.';
import useBrokerManagementApi from '../../api/useBrokerManagementApi';

export const useAssignees = () => {
  const [assignees, setAssignees] = useState<Assignee[]>([]);

  const { getAssignees } = useBrokerManagementApi();

  const { user } = useUser();

  const fetchAssignees = useCallback(async () => {
    if (user?.companyId) {
      const result = await getAssignees(user.companyId);
      setAssignees(result.users);
    }
  }, []);

  return {
    assignees,
    setAssigneesData: setAssignees,
    fetchAssignees,
  };
};
